<section class="img-container img-fluid mb-5">
  <img src="../../../assets/img/flygets-buss-image.jpg" alt="airplane" class="width-100">
  <!-- <div class="centered">
    <h1 class="text-white">Flygets Långtidsparkering</h1>
    <p class="lead text-white">Varmt Välkomna</p>
  </div> -->
</section>

<div class="text-center container">
  <h2>{{ 'FINDUS.TITLE' | transloco }}</h2>
  <p class="lead">{{ 'FINDUS.BODY1' | transloco }}</p>
  <p class="font-bold">{{ 'FINDUS.SOUTHBOUND.TITLE' | transloco }}<br></p>
    <ul>
      <li>{{ 'FINDUS.SOUTHBOUND.STEP1' | transloco }}</li>
      <li>{{ 'FINDUS.SOUTHBOUND.STEP2' | transloco }}</li>
      <li>{{ 'FINDUS.SOUTHBOUND.STEP3' | transloco }}</li>
      <li>{{ 'FINDUS.SOUTHBOUND.STEP4' | transloco }}</li>
    </ul>

    <p class="font-bold">{{ 'FINDUS.NORTHBOUND.TITLE' | transloco }}<br></p>
    <ul>
      <li>{{ 'FINDUS.NORTHBOUND.STEP1' | transloco }}</li>
      <li>{{ 'FINDUS.NORTHBOUND.STEP2' | transloco }}</li>
      <li>{{ 'FINDUS.NORTHBOUND.STEP3' | transloco }}</li>
      <li>{{ 'FINDUS.NORTHBOUND.STEP4' | transloco }}</li>
      <li>{{ 'FINDUS.NORTHBOUND.STEP5' | transloco }}</li>
      <li>{{ 'FINDUS.NORTHBOUND.STEP6' | transloco }}</li>
      <li>{{ 'FINDUS.NORTHBOUND.STEP7' | transloco }}</li>
    </ul>

      <p class="font-bold">{{ 'FINDUS.CHECKIN.TITLE' | transloco }}</p>
      <p>{{ 'FINDUS.CHECKIN.BODY1' | transloco }}</p>
      <p>{{ 'FINDUS.CHECKIN.BODY2' | transloco }}</p>

      <p class="font-bold">{{ 'FINDUS.CONTACT.TITLE' | transloco }}</p>
      <p>
        <b>{{ 'FINDUS.CONTACT.ADDRESS.TITLE' | transloco }}</b> {{ 'FINDUS.CONTACT.ADDRESS.BODY' | transloco }}<br>
        <b>{{ 'FINDUS.CONTACT.COORDINATES1.TITLE' | transloco }}</b> N 59°36'18.8&quot;, E 17°54'10.7&quot;<br>
        <b>{{ 'FINDUS.CONTACT.COORDINATES2.TITLE' | transloco }}</b> {{ 'FINDUS.CONTACT.COORDINATES2.BODY' | transloco }}<br><br>
        <b>{{ 'FINDUS.CONTACT.MAIL.TITLE' | transloco }}</b>&nbsp;<a href="mailto:info@flygets.se">info&#64;flygets.se</a><br>
        <b>{{ 'FINDUS.CONTACT.WEB.TITLE' | transloco }}</b>&nbsp;{{ 'FINDUS.CONTACT.WEB.BODY' | transloco }}<br>
        <b>{{ 'FINDUS.CONTACT.TELEPHONE.TITLE' | transloco }}</b>&nbsp;{{ 'FINDUS.CONTACT.TELEPHONE.BODY' | transloco }}<br>
      </p>
        
  <button class="my-3" mat-raised-button routerLink="/flygets/flygets-start">{{'Tillbaka till start' |
    uppercase}}
  </button>

</div>

<div class="container">
  <div class="map match-parent" id="map"></div>
</div>

<div class="jumbotron jumbotron-fluid mt-4">
  <div class="container">
    <p class="lead">{{ 'FLYGETS.CONTACT.TEXT1' | transloco }}</p>
    <a [routerLink]="['/flygets/kontakta-oss']">{{ 'FLYGETS.CONTACT.FORM' | transloco }}</a><br>
    <a href="mailto: info@flygets.se">info&#64;flygets.se</a><br>
    <a href="tel: 010-330 03 33"> 010-330 03 33</a>
    <p class="lead">{{ 'FLYGETS.CONTACT.TEXT3' | transloco }}</p>
  </div>
</div>

<app-small-footer></app-small-footer>
